import axios from 'axios';

// Base URL for internal communication (same EC2 machine)
const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE}/api/license`,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true, // Allow cookies if needed
});

export default api;
